// ============================================================
// OFFER EDIT PERMISSIONS
// ============================================================
// Only fields listed here will be editable for that stage/role.
// Any field NOT listed here should remain read-only.
//
// MIRROR OF hr_backend/src/config/offerEditableFields.js — that copy is the one
// that is enforced. updateStageOffer() keeps only the whitelisted keys out of
// the request body, so anything not listed here (or there) is dropped and the
// approver would see "saved" with no change. The two lists must stay identical.
//
// Which stage uses which role (backend STAGE_EDITOR):
//   stage 1 -> hiring_manager   stage 2 -> bu_head   stage 3 -> hr
// A draft or sent-back offer uses `recruiter` via PUT /offers/:id/draft.
//
// Future changes:
// Add/remove a field name here AND in the backend mirror.
// No need to change the permission logic in OffersList.js.
// ============================================================

export const EDITABLE_FIELDS = {
  recruiter: [
    "candidate_name",
    "salutation",
    "address",
    "expected_doj",
    "location_offered",
    "offered_company",
    "business_unit",
    "division",
    "department",
    "offer_type",
    // Compensation. The Annexure-A breakup is derived from the fixed CTC on
    // the server, so editing the fixed CTC is what changes the letter.
    "offered_ctc_fixed",
    "offered_ctc_variable",
    "offered_ctc_variable_amount",
    "variable_annual_pay_amount",
    "variable_retention_bonus_amount",
  ],

  hiring_manager: [
    "salutation",
    "location_offered",
    "offered_company",
    "joining_bonus",
    "joining_bonus_amount",
    "retention_bonus",
    "retention_total",
    "retention_installment1_date",
    "retention_installment1_amount",
    "grade",
    "designation",
  ],

  bu_head: [
    "salutation",
    "location_offered",
    "offered_company",
    "joining_bonus",
    "joining_bonus_amount",
    "retention_bonus",
    "retention_total",
    "retention_installment1_date",
    "retention_installment1_amount",
    "grade",
    "designation",
  ],

  hr: [
    "candidate_name",
    "salutation",
    "address",
    "location_offered",
    "offered_company",
    "grade",
    "designation",
    // Compensation - the final approver owns the numbers on the letter.
    "offered_ctc_fixed",
    "offered_ctc_variable",
    "offered_ctc_variable_amount",
    "variable_annual_pay_amount",
    "variable_retention_bonus_amount",
  ],
};

// ============================================================
// Helper
// ============================================================

export const getEditableFields = (role) => {
  return EDITABLE_FIELDS[role] || [];
};

export const isFieldEditable = (role, fieldName) => {
  return getEditableFields(role).includes(fieldName);
};